import { render, staticRenderFns } from "./scada.vue?vue&type=template&id=2c8a4b5e&lang=pug&"
import script from "./scada.vue?vue&type=script&lang=js&"
export * from "./scada.vue?vue&type=script&lang=js&"
import style0 from "./scada.vue?vue&type=style&index=0&id=2c8a4b5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports